import GaEvent from './GaEvent';

export default class BookingFormOpenedGaEvent extends GaEvent {
  constructor() {
    super('booking_form_opened');
  }
}
